import { HTMLAttributes, useMemo } from 'react';

import { EmailBuilder } from '../../email-builder';
import { Attribute } from './attribute';
import { FieldWrapper } from './field-wrapper';
import { parseEmailBuilderDocument } from './utils/parse-email-builder-document';

export type { EmailBuilderAttribute } from './attribute';

interface FormRenderEmailBuilderProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  attribute: Attribute;
}

/**
 * FormRenderEmailBuilder
 * Uncontrolled: seeds the document from `attribute.emailBuilder.value` (a serialized `{ root }` JSON string)
 * and exposes `getContent()` (`{ json, html }`) through `attribute.emailBuilder.ref`.
 */
export function FormRenderEmailBuilder({ attribute, className }: FormRenderEmailBuilderProps) {
  // Memoized by raw string so unrelated re-renders (e.g. RHF `form.watch()`) don't produce a new
  // object reference on every keystroke elsewhere in the form.
  const value = useMemo(
    () => parseEmailBuilderDocument(attribute?.emailBuilder?.value),
    [attribute?.emailBuilder?.value],
  );

  return (
    <FieldWrapper className={className} {...attribute}>
      <EmailBuilder
        emailBlocksElement={attribute?.emailBuilder?.emailBlocksElement}
        isBlock={attribute?.emailBuilder?.isBlock}
        mediaPicker={attribute?.emailBuilder?.mediaPicker}
        ref={attribute?.emailBuilder?.ref}
        savedBlocks={attribute?.emailBuilder?.savedBlocks}
        theme={attribute?.theme === 'dark' ? 'dark' : 'light'}
        value={value}
        onSaveBlock={attribute?.emailBuilder?.onSaveBlock}
      />
    </FieldWrapper>
  );
}
